
import { Button, Grid } from "@material-ui/core";
import { useRef } from "react";
import { useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import BuscadorMateriales from "../../autorizaciones/UI/BuscadorMateriales";
import { useDispatch } from "react-redux";
import {  setMaterialCompras } from "../../../actions/compras/Cotizaciones";
import { useForm } from "../../../hooks/useForm";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import moment from "moment";

export const FormNuevoMaterial = (props) => {
    const dispatch = useDispatch();
    const { material } = props;
    const { idCotizacionCabecera, idOferente } = props;
    const [codigoMaterial, setCodigoMaterial] = useState(null);
    const codigoMaterialRef = useRef(null);

    const formInicial = {
        idMaterial: "",
        cantidad: "",
        cantidadCotizada: "",
        valorUnitario: "",
        fechaEntrega: "",
        observaciones: "",
        idCotizacionCabecera: idCotizacionCabecera,
        idOferente: idOferente,
        material : "",
        agregadoCompras: true, 

    }
    
    const [formValues, handleInputChange, , setearValor] = useForm(material ? material : formInicial);

    
    const handleSave = (e) => {
        e.preventDefault();
        formValues.idMaterial = material ? material.idMaterial : codigoMaterial.codigoNum; 
        formValues.material = material ? material.material : codigoMaterial.descripcion;
        if(material !== null){
            props.handleEdit(formValues);
        }else{
            dispatch(setMaterialCompras(formValues));
        }
    }
    console.log(formValues)
    return (
        <ValidatorForm onSubmit={handleSave}>
        <Grid container style={{padding:25}}>
            {material === null &&
            <Grid item xs={12} sm={10} md={8} lg={6} style={{ paddingRight: "0.5rem" }} >
                <BuscadorMateriales
                    ref={codigoMaterialRef}
                    cod={codigoMaterial}
                    label="Código Material"
                    setCod={(val) => setCodigoMaterial(val)}
                />
            </Grid>
}
            <Grid item xs={12} md={6}>
                <TextValidator
                    margin="normal"
                    name="idMaterial"
                    value={material ? material.material : codigoMaterial?.descripcion !== undefined ? codigoMaterial.descripcion : ""}
                    autoComplete="off"
                    fullWidth
                    style={{  paddingRight:"0.5rem" }}
                    validators={["required"]}
                />
            </Grid>
            <Grid item xs={12} md={6} style={{ marginTop: material === null ? '1rem' : ''}}>
                <TextValidator
                    name="cantidad"
                    required='true'
                    label='Cantidad'
                    value={formValues.cantidad}
                    onChange={handleInputChange}
                    fullWidth
                    style={{ paddingRight: "0.5rem" }}
                />
            </Grid>
            <Grid item xs={12} md={6} style={{marginTop:'1rem'}}>
                <TextValidator
                    name="cantidadCotizada"
                    required='true'
                    label='Cantidad Cotizada'
                    value={formValues.cantidadCotizada}
                    onChange={handleInputChange}
                    fullWidth
                    style={{ paddingRight: "0.5rem" }}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextValidator
                    margin="normal"
                    label="Precio Unitario"
                    name="valorUnitario"
                    value={formValues.valorUnitario}
                    autoComplete="off"
                    onChange={handleInputChange}
                    fullWidth
                    style={{ paddingRight: "0.5rem" }}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextValidator
                    margin="normal"
                    label="Observaciones"
                    name="observaciones"
                    value={formValues.observaciones}
                    autoComplete="off"
                    onChange={handleInputChange}
                    fullWidth
                    style={{ paddingRight: "0.5rem" }}
                />
            </Grid>
            <Grid  item xs={12} md={6} >
                <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                    <ValidatedDatePicker
                        style={{ marginTop: material === null ? '0.5rem' : '1rem'}}
                        label="Fecha Entrega"
                        format="dd/MM/yyyy"
                        onChange={(e) => setearValor("fechaEntrega", moment(e).format())}
                        name='fechaEntrega'
                        minDate={new Date()}
                        value={formValues.fechaEntrega}
                        fullWidth
                    />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid container style={{margin:'2rem'}}>
                <Grid item xs={12}>
                    <Grid
                        container
                        spacing={1}
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                    >
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            startIcon={<CancelIcon />}
                            onClick={props.cerrarModal}
                        >
                            CANCELAR
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            startIcon={<SaveIcon />}
                            type='submit'
                            style={{ marginLeft: "0.5rem" }}
                            onClick={props.cerrarModal}
                        >
                            GUARDAR
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        </ValidatorForm>
    );
}